import _ from 'lodash'
import i18n from '@/i18n'

// Example code
// import responseMessage from '@/utils/responseMessage'

const messages = {
  createOrder: {
    80001: 'orderErrorMsg.roomStockNotEnough',
    80002: 'orderErrorMsg.planNotOpening',
    80003: 'orderErrorMsg.roomNotOpening',
    80031: 'orderErrorMsg.invalidGroupBuying',
    81001: 'orderErrorMsg.invalidAddonItem',
    81002: 'orderErrorMsg.invalidQuantity',
    70108: 'orderErrorMsg.couponCantUseForTheHotel',
    70106: 'orderErrorMsg.insufficientSupplyOfCoupons',
    70110: 'orderErrorMsg.couponPlatformRestrictions',
    70005: 'orderErrorMsg.youHasThisCoupon',
    40003: 'orderErrorMsg.hotelAlreadyFullBooking',
    30006: 'orderErrorMsg.createUserFail',
    30007: 'orderErrorMsg.mailForgottenPasswordFail',
    11032: 'orderErrorMsg.invalidDateRange',
    11036: 'orderErrorMsg.invalidStartDate'
  },
  // POST Order
  postOrder: {
    11013: 'orderErrorMsg.invalidCoupon',
    11015: 'orderErrorMsg.isPremiumOnly',
    11024: 'orderErrorMsg.duplicateCoupon',
    11034: 'orderErrorMsg.onlyForFirstBuy',
    11035: 'orderErrorMsg.duplicateRandomCode',
    81003: 'orderErrorMsg.duplicatePaidOrder',
    81008: 'orderErrorMsg.orderUpdateFailed',
    81004: 'orderErrorMsg.expiredOrder',
    30006: 'orderErrorMsg.assignOrderFailed',
    404: 'orderErrorMsg.couponNotFound',
    70005: 'orderErrorMsg.couponIsRedeemed',
    70106: 'orderErrorMsg.reachedCouponLimit',
    70002: 'orderErrorMsg.couponIsUsed',
    70003: 'orderErrorMsg.expiredCoupon',
    70004: 'orderErrorMsg.couponIsNotAllowedForThisHotel',
    70013: 'orderErrorMsg.couponNotReadyToRedeem',
    70110: 'orderErrorMsg.couponPlatformRestrictions',
    4105: 'orderErrorMsg.isUnderRedeemBasePrice'
  },
  // Create Coupon
  createCoupon: {
    404: 'orderErrorMsg.couponCodeNotFound',
    70106: 'orderErrorMsg.couponReachedLimitOrDuplicated',
    70108: 'orderErrorMsg.couponIsNotAllowedForThisHotel',
    70005: 'orderErrorMsg.couponIsRedeemed',
    4105: 'orderErrorMsg.isUnderRedeemBasePrice'
  }
}

export default function (type, code, msg = null) {
  if (!_.get(messages, `${type}.${code}`)) {
    console.error(`😧 [Response Message] Missing ${type} - ${code} translation`)
    return i18n.t('pleaseRetryLater') + ` (code: ${type}_${code})`
  } else {
    if (msg) {
      return msg
    }
    return i18n.t(_.get(messages, `${type}.${code}`))
  }
}

// MEMO: 未列入錯誤
// // 200
// 80022 child 數量 跟 age 對不上
// 0 'during_start_not_valid' 日期小於今日 / 日期是今日，但旅館不接受今日訂房
// 20000 'error_parameter' require 的東西沒給 或 格式不合
// 0 'bed_count' 床數量跟人數不同
// 404 room_not_exist 房間不存在 / Plan 不存在 / 完全沒庫存
// 80001 'roomStockNotEnough' 庫存不足
// 80003 'roomNotOpening' 房間沒開
// 40003 'hotelAlreadyFullBooking'
// 70001 user_coupon_error, discount unit undefind
// 4105 untaxed_price_too_lower 未稅價太低
// // 500
// 時間格式錯誤
